import React from "react"
import PropTypes from "prop-types"

const JsonLd = ({ schema }) => {
  if (!schema) return null

  return (
      <script 
        type="application/ld+json"
      // Inhalt aus Repo/CMS, kein User-Input. `<` wird escaped, damit ein
      // `</script>` in den Daten nicht ausbrechen kann.
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema).replace(/</g, "\\u003c"),
        }}
      />
  )
}

export default JsonLd

JsonLd.propTypes = {
  schema: PropTypes.object,
}
